import { withLocalState } from 'pyradux';

import DataContainer from './Data.container';
import reducer from './Data.reducer';
import DataSagas from './Data.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'data',
  sagas: [DataSagas],
};

export default withLocalState(withLocalStateOptions, DataContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/index.js